module.exports = __webpack_public_path__ + "img/user-menu-user.505f28fc.svg";